import React from 'react';
import { View, StyleSheet } from 'react-native';
import PropTypes from 'prop-types';

import * as Layout from '@components/screen/Layout';
import SociollaCard from '@components/sociolla/SociollaCard';
import SociollaText from '@components/sociolla/SociollaText';
import Highcharts from '@components/chart/Highcharts';
import Colors from '@global/colors';
import { isWeb } from '@global/screens';

// The mockup's axis wording, keyed by the API's bucket id. The buckets are half-open on whole
// minutes, so `10-20 min` here means 10 up to but not including 20.
const BUCKET_LABELS = {
  '0-9': '< 10 min',
  '10-19': '10\u201320 min',
  '20-29': '20\u201330 min',
  '30+': '> 30 min',
};

const SalesmanDurationChart = ({ buckets, loading, error, style }) => {
  const body = () => {
    if (loading) {
      return <Layout.Loader />;
    }
    if (error) {
      return (
        <SociollaText style={styles.unavailable}>Unavailable</SociollaText>
      );
    }
    return (
      <Highcharts
        type="column"
        height={isWeb ? 320 : 260}
        showCategories={false}
        categories={buckets.map(
          (bucket) => BUCKET_LABELS[bucket.bucket] || `${bucket.bucket} min`,
        )}
        // The bar is the count; its label is the share of visits with a check-in.
        dataLabelFormat="{point.pct}%"
        dataLabelColor={Colors.green2}
        data={[
          {
            name: 'Visits',
            data: buckets.map((bucket) => ({
              y: bucket.count,
              pct: bucket.pct,
            })),
          },
        ]}
      />
    );
  };

  return (
    <SociollaCard style={[styles.card, style]}>
      <SociollaText type="medium" style={styles.title}>
        Visit Duration Distribution
      </SociollaText>
      <View style={styles.chart}>{body()}</View>
    </SociollaCard>
  );
};

SalesmanDurationChart.propTypes = {
  buckets: PropTypes.arrayOf(
    PropTypes.shape({
      bucket: PropTypes.string,
      count: PropTypes.number,
      pct: PropTypes.number,
    }),
  ),
  loading: PropTypes.bool,
  error: PropTypes.bool,
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

SalesmanDurationChart.defaultProps = {
  buckets: [],
  loading: false,
  error: false,
  style: null,
};

const styles = StyleSheet.create({
  card: { marginBottom: 0, padding: 16 },
  chart: { justifyContent: 'center', minHeight: isWeb ? 320 : 260 },
  title: { fontSize: 16, marginBottom: 16 },
  unavailable: { color: Colors.red0, fontSize: 16, textAlign: 'center' },
});

export default SalesmanDurationChart;
